export default __webpack_public_path__ + "static/26-148d5a1fcde60ff531fc6f495905cf66.png";